import {
  create_s_product,
  update_s_product,
  delete_s_product,
  recover_s_product,
  query_s_product_list,
} from '@/api/mjstock-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstock/mjstock-sproduct-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '存货编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '存货名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货名称',
    },
    {
      type: 'input',
      name: 'gg',
      label: '存货规格',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货规格',
    },
    {
      type: 'remoteselect',
      name: 'product_type_id',
      label: '存货类别',
      disabled: false,
      placeholder: '请选择存货类别',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-sproducttype',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    gg: null,
    product_type_id: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    {
      value: True,
      name: '可用',
    },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '存货名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货名称',
    },
    {
      type: 'input',
      name: 'gg',
      label: '存货规格',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货规格',
    },
    {
      type: 'input',
      name: 'dw',
      label: '存货单位',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货单位',
    },
    {
      type: 'remoteselect',
      name: 'product_type_id',
      label: '存货类别',
      disabled: false,
      placeholder: '请选择存货类别',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-sproducttype',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入存货名称' }],
    dw: [{ required: true, message: '请填输入存货单位' }],
    gg: [{ required: true, message: '请填写存货规格' }],
    product_type_id: [{ required: true, message: '请选择存货类别' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    gg: null,
    dw: null,
    product_type_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '存货名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货名称',
    },
    {
      type: 'input',
      name: 'gg',
      label: '存货规格',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货规格',
    },
    {
      type: 'input',
      name: 'dw',
      label: '存货单位',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写存货单位',
    },
    {
      type: 'remoteselect',
      name: 'product_type_id',
      label: '存货类别',
      disabled: false,
      placeholder: '请选择存货类别',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-sproducttype',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入存货名称' }],
    dw: [{ required: true, message: '请填输入存货单位' }],
    gg: [{ required: true, message: '请填写存货规格' }],
    product_type_id: [{ required: true, message: '请选择存货类别' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    gg: null,
    dw: null,
    product_type_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '商品管理',
  addModalTitle: '新建商品',
  updateTitle: '修改商品',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    sproduct_id: 'id',
  },
  delete: {
    sproduct_id: 'id',
  },
  recover: {
    sproduct_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    sproduct_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },

  {
    title: '存货编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '存货名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '存货规格',
    dataIndex: 'gg',
    checked: true,
  },
  {
    title: '存货单位',
    dataIndex: 'dw',
    checked: true,
  },
  {
    title: '存货类别',
    dataIndex: 'product_type__name',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_s_product_list,
    addData: create_s_product,
    updateData: update_s_product,
    removeData: delete_s_product,
    recoverData: recover_s_product,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
